import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="custom-app-theme"
export default class extends Controller {
	static targets = ["logoPreview", "farbfeld"]

	connect() {}

	showImage({ currentTarget }) {
		if (currentTarget.files && currentTarget.files[0]) {
			const reader = new FileReader()

			reader.onload = (e) => {
				this.logoPreviewTarget.src = e.target.result
			}
			reader.readAsDataURL(currentTarget.files[0])
		}
	}

	showColor({ currentTarget }) {
		if (currentTarget.value.length == 7) {
			this.farbfeldTarget.style.backgroundColor = currentTarget.value
			this.farbfeldTarget.style.borderWidth = "0px"
		} else {
			this.farbfeldTarget.style.backgroundColor = "white"
			this.farbfeldTarget.style.borderWidth = "1px"
		}
	}
}
